import { AuditSchedule, DateStr, Station, toDateRange, today } from '@mi-front/core';
import { apiClient } from '../../../../../../api';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { ListingView } from '../../../../../../core/reports/components/ListingView';
import { ListingType } from '../../../../../../core/reports/types';
import { SchedulesListMentionsForm } from './form';
import { SchedulesListMentionsResult } from './result';

interface Props {
  readonly station: Station;
}

export type SchedulesMentionsListing = ListingType<
  { from: string; to: string; customId: string },
  AuditSchedule
>;

export function SchedulesMentionsListView(p: Props) {
  const tz = useTimezone();

  return (
    <ListingView<SchedulesMentionsListing>
      defaultValues={{
        ...toDateRange(today() as DateStr, tz),
        customId: '',
        sort: 'datetime desc',
      }}
      queryParamsTransform={{
        customId: {
          serialize: (input: string) => {
            return input.replace(/\s/g, '');
          },
        },
      }}
      reportFn={async (values) => {
        return apiClient.audit.fetchSchedules(p.station.slug, {
          ...values,
          page: values.pageIndex,
          filter: {
            type: 'MENTION',
            'datetime.gte': values.from,
            'datetime.lte': values.to,
            customId: values.customId
              ?.split(',')
              .filter((v) => !!v)
              .map((v) => v.trim()),
          },
          contain: 'mentionMatch',
        });
      }}
      Form={SchedulesListMentionsForm}
      Result={SchedulesListMentionsResult}
    />
  );
}
